(() => {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-tonsor-events]').forEach(root => {
      if (root.dataset.eventsReady) return;
      root.dataset.eventsReady = 'true';
      root.querySelectorAll('[data-event-gallery]').forEach(gallery => {
        const viewport = gallery.querySelector('[data-slot="carousel-content"]');
        const slides = Array.from(gallery.querySelectorAll('[data-slot="carousel-item"]'));
        const dots = Array.from(gallery.querySelectorAll('[data-gallery-index]'));
        const caption = gallery.querySelector('.gallery-caption');
        if (!viewport || !slides.length || !caption) return;
        let selected = -1;
        let frame = 0;
        function current() { return Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1)))); }
        function update() {
          frame = 0;
          const index = current();
          if (index === selected) return;
          selected = index;
          const number = document.createElement('span');
          number.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
          caption.replaceChildren(number, document.createTextNode(slides[index].dataset.caption));
          dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        }
        function go(index) {
          index = (index + slides.length) % slides.length;
          viewport.scrollTo({left: index * viewport.clientWidth, behavior: 'instant'});
          update();
        }
        gallery.querySelectorAll('[data-gallery-direction]').forEach(button => {
          button.addEventListener('click', () => go(current() + (button.dataset.galleryDirection === 'next' ? 1 : -1)));
        });
        dots.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.galleryIndex))));
        gallery.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); go(current() + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        viewport.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive: true});
        update(); gallery.classList.add('is-enhanced');
      });
      root.querySelectorAll('a[href="#te-projet"]').forEach(link => link.addEventListener('click', () => {
        const place = root.querySelector('#te-place');
        const type = root.querySelector('#te-event');
        if (link.dataset.eventPlace && place) place.value = link.dataset.eventPlace;
        if (link.dataset.eventType && type) type.value = link.dataset.eventType;
        requestAnimationFrame(() => root.querySelector('#te-nom')?.focus({preventScroll: true}));
      }));
      root.querySelector('.event-contact-form .notice')?.focus({preventScroll: false});
    });
  }
  init(document);
  if (!window.tonsorEventsListenerReady) {
    window.tonsorEventsListenerReady = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
